import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type Theme = 'light' | 'dark';

@Injectable({ providedIn: 'root' })

export class ThemeService {
  private themeSubject = new BehaviorSubject<Theme>('light');
  theme$ = this.themeSubject.asObservable();

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(DOCUMENT) private document: Document
  ) {
    const savedTheme = isPlatformBrowser(this.platformId)
      ? (this.readStoredTheme() || 'light')
      : 'light';
    this.setTheme(savedTheme);
  }

  toggleTheme() {
    const newTheme = this.themeSubject.value === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
  }

  setTheme(theme: Theme) {
    this.themeSubject.next(theme);
    if (!isPlatformBrowser(this.platformId)) return;

    try {
      window.localStorage.setItem('theme', theme);
    } catch {
      // Storage can be disabled by the browser.
    }

    if (theme === 'dark') {
      this.document.documentElement.classList.add('dark');
      this.document.body.classList.add('dark:bg-gray-900');
    } else {
      this.document.documentElement.classList.remove('dark');
      this.document.body.classList.remove('dark:bg-gray-900');
    }
  }

  private readStoredTheme(): Theme | null {
    try {
      const theme = window.localStorage.getItem('theme');
      return theme === 'dark' || theme === 'light' ? theme : null;
    } catch {
      return null;
    }
  }
}
